module.exports = __webpack_public_path__ + "media/25.a441de6b.mp3";